/// =======================================================================================
/// Global Events
/// =======================================================================================


/// *** => Used By Theme
/// gets event target details
function getEventTarget(e) {
    e = e || window.event;
    return e.target || e.srcElement;
}

/// *** => Used By Theme
/// helper for adding on all elements multiple attributes
function setAttributes(el, options) {
    Object.keys(options).forEach(function (attr) {
        el.setAttribute(attr, options[attr]);
    })
}

/// *** => Used By Theme
/// activate popovers
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})

/// *** => Used By Theme
/// activate tooltips
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
})


/// =======================================================================================
/// SignalR Methods
/// =======================================================================================
function setupLiveSignalR() {
    connection = new signalR.HubConnectionBuilder().withUrl(`/webHub`).build();

    connection.on("ReceiveMessage", function (user, message) {
        console.info(`'==>SignalR::${user} says ${message}`);
    });

    connection.on("WebCount", function (data) {
        DEBUG && console.log(`==>SignalR::Updating WebCount: ${data}`);
    });

    connection.on("melbourneLive", function (data) {
        DEBUG && console.log(`==>SignalR::Updating melbourneLive: ${data}`);
        showHideLiveToast(data, 'melbourneLive');
    });

    connection.on("vieraLive", function (data) {
        DEBUG && console.log(`==>SignalR::Updating vieraLive: ${data}`);
        showHideLiveToast(data, 'vieraLive');
    });

    connection.start();    
}

/// =======================================================================================
/// Method used by SignalR to Control Toast
/// =======================================================================================
function showHideLiveToast(data, stream) {

    var elements = document.querySelectorAll(`[data-stream="${stream}"]`);

    if (data == "True") {
        // Show the Live Toast
        elements.forEach(element => {

            // Check that the page is NOT a 'live' page
            if (!window.location.href.includes('live')) {
                element.style.display = 'block';
            }

        });
    }
    else {
        // Hide the Live Toast
        elements.forEach(element => {
            element.style.display = 'none';
        });
    }

}

/// =======================================================================================
/// Site Wide Setup Options
/// =======================================================================================

/// SetupLiveSignalR
setupLiveSignalR();

